<template>
  <b-overlay :show="busy" rounded="sm">
    <b-card class="standardpage reports invoices border-none">
      <div class="availtable datatable">
        <b-card class="w-100pct">
          <!-- <b-card-header class="py-1 mb-2">
        <i :class="options.icon" class="text-primary mr-1"></i>
        {{ item.name }}
        <span class="text-warning"
          >&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span
        >
      </b-card-header> -->
          <b-card-body class="py-0 px-0">
            <b-tabs class="gridtabs">
              <b-tab active>
                <template #title>
                  <i :class="options.icon" class="text-primary mr-1"></i>
                  {{ item.locator }}
                  <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span>
                </template>
                <p class="py-3 px-0">
                  <b-row>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Locator" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="item.locator" :debounce="options.debounce" :disabled="true"
                            placeholder="Enter locator"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" :disabled="true" @click="item.locator = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Date Issued" label-size="sm">
                        <!-- v-model="item.dateissued" -->
                        <b-input-group>
                          <b-form-input :disabled="true" :value="$moment
                              .unix(item.dateissued / 1000)
                              .format('YYYY-MM-DD HH:mm:ss')
                            " :debounce="options.debounce"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" :disabled="true"
                              @click="item.dateissued = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Agent" label-size="sm">
                        <b-input-group>
                          <b-form-input :disabled="true" v-model="item.creationagentid" :debounce="options.debounce"
                            placeholder="Enter Agent"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" :disabled="true"
                              @click="item.creationagentid = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Doc Date" label-size="sm">
                        <b-input-group>
                          <b-form-input :disabled="true" v-model="item.docdate" :debounce="options.debounce"
                            placeholder="Doc Date"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" :disabled="true" @click="item.docdate = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Doc Number" label-size="sm">
                        <b-input-group>
                          <b-form-input :disabled="true" v-model="item.docnumber" :debounce="options.debounce"
                            placeholder="Enter Doc Number"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" :disabled="true" @click="item.docnumber = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="File Ref" label-size="sm">
                        <b-input-group>
                          <b-form-input :disabled="true" v-model="item.fileref" :debounce="options.debounce"
                            placeholder="File Ref"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" :disabled="true" @click="item.fileref = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Branch" label-size="sm">
                        <b-input-group>
                          <b-form-input :disabled="true" v-model="item.branch" :debounce="options.debounce"
                            placeholder="Branch"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" :disabled="true" @click="item.branch = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Source" label-size="sm">
                        <b-input-group>
                          <b-form-input :disabled="true" v-model="item.source" :debounce="options.debounce"
                            placeholder="Source"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" :disabled="true" @click="item.source = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Booking Type" label-size="sm">
                        <b-input-group>
                          <b-form-input :disabled="true" v-model="item.bookingtype" :debounce="options.debounce"
                            placeholder="Booking Type"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" :disabled="true"
                              @click="item.bookingtype = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Handoff Type" label-size="sm">
                        <b-input-group>
                          <b-form-input :disabled="true" v-model="item.handofftype" :debounce="options.debounce"
                            placeholder="Handoff Type"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" :disabled="true"
                              @click="item.handofftype = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Creation Date" label-size="sm">
                        <b-input-group>
                          <b-form-input :disabled="true" v-model="item.creationdate"
                            :debounce="options.debounce"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" :disabled="true"
                              @click="item.creationdate = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </p>
              </b-tab>

              <b-tab>
                <template #title>
                  <i class="fa fa-file-code-o text-primary mr-1"></i>
                  Data</template>
                <p class="py-3 px-0">
                  <b-row>
                    <b-col cols="12">
                      <b-form-group label="Data" label-for="data" label-cols="12">
                        <b-form-textarea id="data" v-model="item.data" placeholder="Enter data" rows="12"
                          class="smalltextarea courier" :disabled="admin"></b-form-textarea>
                      </b-form-group> </b-col></b-row>
                </p>
              </b-tab>
              <b-tab v-if="idselected">
                <template #title>
                  <i class="fa fa-history text-primary mr-1"></i>Audit
                </template>
                <p class="py-3 px-0">
                  <b-row>
                    <b-col cols="12" sm="6">
                      <b-form-group label="ID" label-for="id" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.id" placeholder="" size="sm"
                            :disabled="true"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.id = ''" :disabled="true">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group> </b-col></b-row>
                  <b-row>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Created At" label-for="created_at" label-cols="12">
                        <b-input-group>
                          <b-input-group-prepend>
                            <b-form-datepicker size="sm" v-model="item.created_at" button-only label-help=""
                              locale="en-GB" :disabled="true"></b-form-datepicker>
                          </b-input-group-prepend>
                          <b-form-input size="sm" id="date" v-model="item.created_at" type="text" placeholder="YYYY-MM-DD"
                            autocomplete="off" :disabled="true"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.created_at = null"
                              :disabled="true">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Created By" label-for="created_by" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.created_by" placeholder="" size="sm"
                            :disabled="true"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.created_by = ''"
                              :disabled="true">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                        <b-input-group>
                          <b-input-group-prepend>
                            <b-form-datepicker size="sm" v-model="item.updated_at" button-only label-help=""
                              locale="en-GB" :disabled="true"></b-form-datepicker>
                          </b-input-group-prepend>
                          <b-form-input size="sm" id="date" v-model="item.updated_at" type="text" placeholder="YYYY-MM-DD"
                            autocomplete="off" :disabled="true"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.updated_at = null"
                              :disabled="true">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.updated_by" placeholder="" size="sm"
                            :disabled="true"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.updated_by = ''"
                              :disabled="true">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </p>
              </b-tab>
            </b-tabs>
          </b-card-body>
          <b-card-footer class="nopadding mt-2">
            <b-row no-gutters>
              <b-col cols="auto" class="text-left mr-3">
                <b-button squared size="sm" variant="primary" @click="saveit"
                  v-if="user.permissions.includes('pnrlibrary.save')">
                  <i class="fa fa-check"></i>
                  Save It
                </b-button>
              </b-col>
              <b-col class="text-left my-auto">
                <div v-if="busy">
                  <i class="fa fa-spinner fa-spin text-primary"></i>
                </div>
                <div v-else>
                  <span v-html="message"></span>
                </div>
              </b-col>
              <b-col class="text-right" cols="8">
                <b-button squared size="sm" variant="secondary" class="mr-1" @click="discard">
                  <i class="fa fa-chevron-left pr-1"></i>
                  Back
                </b-button>
              </b-col>
            </b-row>
          </b-card-footer>

        </b-card>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import moment from "moment";

export default {
  name: "PNREdit",
  data() {
    return {
      busy: false,
      message: "",
      id: null,
      item: {
        locator: null,
        agent: null,
        data: null,
        dateissued: this.$moment().format("YYYY-MM-DD"),
        docdate: null,
        docnumber: null,
        branch: null,
        source: null,
        bookingtype: null,
        handofftype: null,
        fileref: null,
      },
      options: {
        title: "PNR",
        icon: "fa fa-book",
      },
    };
  },
  computed: {
    readonly() {
      return true;
    },
    admin() {
      if (this.user.rolename == "admin") {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    async load() {
      if (!this.idselected) {
        return;
      }
      this.busy = true;
      let variables = {
        id: this.idselected,
        dateformat: "DD/MM/YYYY HH:MM:SS",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query pnrs($id: String, $dateformat: String) {
              pnrs(id: $id, dateformat: $dateformat) {
                id
                dateissued
                branch
                docnumber
                creationagentid
                docdate
                fileref
                source
                bookingtype
                handofftype
                locator
                creationdate
                data
                created_at
                created_by
                updated_at
                updated_by
              }
            }
          `,
          variables,
        });
        console.log("load", response);

        this.item = response.data.pnrs[0];
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async saveit() {
      this.busy = true;

      let row = {
        id: this.item.id,
        data: this.item.data,
      };

      let variables = {
        // rows: [this.cleanit(this.item)],
        // dateformat: "DD/MM/YY",
        rows: [row],
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation pnrs_save($rows: [PNR_input], $dateformat: String) {
              pnrs_save(rows: $rows, dateformat: $dateformat) {
                id
              }
            }
          `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
  },
};
</script>

<style></style>